














import { Component, Vue } from 'vue-property-decorator';

@Component
export default class GDPRconfirm extends Vue {
  get paths() {
    return this.$store.state.routerPath;
  }

  get storedExam() {
    return this.$store.state.exam;
  }

  // eslint-disable-next-line no-restricted-globals
  private GDPR_ACCEPT_KEY = `${location.hostname}-GDPRaccept`;

  private isAcceptGDPR = false;

  private mounted() {
    // 了承していれば消える
    this.isAcceptGDPR = localStorage.getItem(this.GDPR_ACCEPT_KEY) === '1';
  }

  private acceptGDPR() {
    localStorage.setItem(this.GDPR_ACCEPT_KEY, '1');
    this.isAcceptGDPR = true;
  }
}
